export enum GENDERS {
  MALE = "MALE",
  FEMALE = "FEMALE",
  // OTHER = "OTHER",
}

export enum SKILLS {
  COMMUNICATION = "COMMUNICATION",
  SOCIAL_MEDIA = "SOCIAL_MEDIA",
  EVENT_ORGANIZATION = "EVENT_ORGANIZATION",
  YOUTH_ENGAGEMENT = "YOUTH_ENGAGEMENT",
  EDUCATION_COACHING = "EDUCATION_COACHING",
  COMMUNITY_OUTREACH = "COMMUNITY_OUTREACH",
}

export enum TICKET_STATUSES {
  PENDING = "pending",
  APPROVED_WITH_PENALTY = "approved_with_penalty",
  APPROVED_WITHOUT_PENALTY = "approved_without_penalty",
  REJECTED = "rejected",
}

export enum SKILL_LEVELS {
  EXCEPTIONAL_LEARNER = "EXCEPTIONAL_LEARNER",
  APPROPRIATE_FOR_AGE_LEVEL = "APPROPRIATE_FOR_AGE_LEVEL",
  BOTH = "BOTH",
}

export enum PROFILE_TYPES {
  LEADER = "leader",
  BUILDER = "builder",
}

export enum INDUSTRY_TYPES {
  FOOD_AND_DRINK = "FOOD_AND_DRINK",
  MUSIC = "MUSIC",
  SPORTS = "SPORTS",
  FITNESS = "FITNESS",
  ART = "ART",
  SCIENCE_AND_TECHNOLOGY = "SCIENCE_AND_TECHNOLOGY",
  FILM_AND_MEDIA = "FILM_AND_MEDIA",
  NATURE = "NATURE",
  GROCERY = "GROCERY",
  GENERAL_STORE = "GENERAL_STORE",
  RETAIL_STORE = "RETAIL_STORE",
  FINANCE = "FINANCE",
  MARKETING = "MARKETING",
  EDUCATION = "EDUCATION",
  FIRST_RESPONDER = "FIRST_RESPONDER",
  CONSULTING = "CONSULTING",
  HEALTHCARE = "HEALTHCARE",
  BEAUTY = "BEAUTY",
  HOBBY = "HOBBY",
  HOME_IMPROVEMENT = "HOME_IMPROVEMENT",
  HAIR_NAILS = "HAIR_NAILS",
  PROFESSIONAL_SERVICE = "PROFESSIONAL_SERVICE",
  FACTORY_WAREHOUSE = "FACTORY_WAREHOUSE",
  DENTAL_MEDICAL = "DENTAL_MEDICAL",
  PET_STORE = "PET_STORE",
  LAUNDROMAT = "LAUNDROMAT",
  DRY_CLEANING = "DRY_CLEANING",
  BOOKSTORE_LIBRARY = "BOOKSTORE_LIBRARY",
  SPIRITUAL_FAITH_BASED_CENTRE = "SPIRITUAL_FAITH_BASED_CENTRE",
  CRAFTS = "CRAFTS",
}

export enum DEVICE_TYPES {
  IOS = "IOS",
  ANDROID = "ANDROID",
  WEB = "WEB",
}

export enum NOTIFICATION_PERMISSION {
  DEFAULT = "default",
  DENIED = "denied",
  GRANTED = "granted",
}

export enum AGE_GROUPS {
  GRADES_1_TO_3 = "GRADES_1_TO_3",
  GRADES_4_TO_6 = "GRADES_4_TO_6",
  GRADES_7_TO_8 = "GRADES_7_TO_8",
  GRADES_9_TO_12 = "GRADES_9_TO_12",
}

export enum EVENT_STATUS {
  ALL = "ALL",
  SIGNEDUP = "SIGNED_UP",
  DRAFT = "DRAFT",
  POSTED = "POSTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DISABLED = "DISABLED",
  UPCOMING = "UPCOMING",
  PAST = "PAST",
  WISHLIST = "WISHLIST",
  JOINED = "JOINED",
  WAITLISTED = "WAITLISTED",
  CANCELLATION_PENDING = "CANCELLATION_PENDING",
}

export enum AMBASSADOR_EVENT_STATUS {
  SUBSCRIBED = "SUBSCRIBED",
  ATTENDED = "ATTENDED",
  NOT_ATTENDED = "NOT_ATTENDED",
}

export enum SUBSCRIPTION_TYPES {
  BASIC = "BASIC",
  TIER_1 = "TIER_1",
  TIER_2 = "TIER_2",
}

export enum LANGUAGES {
  ENGLISH = "English",
  SPANISH = "Spanish",
  FRENCH = "French",
  GERMAN = "German",
  CHINESE = "Chinese",
  OTHER = "Other",
}

export enum BAGDE_TYPES {
  EVENT = "event",
  ACHIEVEMENT = "achievement",
}

export enum MIME_TYPES {
  VIDEO = "video",
  IMAGE = "image",
}

export enum RESOURCE_TAGS {
  GUIDES = "Guides",
  TIPS = "Tips",
  INSTRUCTIONS = "Instructions",
  MORE_INSTRUCTIONS = "More Instructions",
  RESOURCES_LIBRARY = "Resources Library",
}

export enum EVENT_TIMEFRAMES {
  ALL = "All",
  PAST = "past",
  THIS_MONTH = "this_month",
  THIS_WEEK = "this_week",
  UPCOMING = "upcoming",
}

export enum MESSAGE_TYPES {
  TEXT = "TEXT",
  MEDIA = "MEDIA",
}

export enum CORE_CONCEPT_TYPE {
  EXCEPTION_LEARNER = "exception_learner",
  APPROPRIATE_FOR_AGE_LEVEL = "appropriate_for_age_level",
}

export enum RESOURCE_TYPE {
  ALL_TYPES = "All Types",
  GUIDES = "Guides",
  TIPS = "Tips",
  INSTRUCTIONS = "Instructions",
  MORE_INSTRUCTIONS = "More Instructions",
  RESOURCE_LIBRARY = "Resource Library",
}
